import { csrfClient } from '@infrastructure/http/httpClient';

let csrfPromise: Promise<void> | null = null;

export const ensureCsrfCookie = (): Promise<void> => {
  if (!csrfPromise) {
    csrfPromise = csrfClient
      .get('/sanctum/csrf-cookie')
      .then(() => undefined)
      .catch((error) => {
        csrfPromise = null;
        throw error;
      });
  }
  return csrfPromise;
};
